<template>
<div>
<informaton/>

</div>
</template>

<script>
import informaton from "../../components/academic/informaton.vue";


export default {
  components: {
   informaton
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>